// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mock-up-image {
    width: 100%;
}


@media (min-width: 768px) {
    .mock-up-image {
        width: initial;
    }
}

.event-info-tile {
    margin-bottom: 1rem;
}

.event-info-tile > header {
    position: sticky;
    top: -16px;
    z-index: 1;
}

.event-info-tile.light-blue header{
    background-color: #005377;
}

.event-info-tile.blue header {
    background-color: #005337;
}

.event-info-tile.red header {
    background-color: #95190d;
}

.event-info-tile.red .sub-header {
    background-color: #C5817B;
    color: white;
    padding: .5rem;
    margin-bottom: 1rem;
    margin-top: 1rem
}

.event-info-tile.yellow header {
    background-color: #edb901;
}

.event-info-tile.teal header {
    background-color: #0894a1;
}

.event-info-tile.tan header {
    background-color: #a4896c;
}

.event-info-tile.cyan header {
    background-color: #BA324F;
}

.event-info-tile.darkBlue header {
    background-color: #003d5a;
}

.event-info-tile.grey header {
    background-color: #034748;
}

.event-info-tile.purple header {
    background-color: #8a8ac0;
}

.event-info-tile.orange header {
    background-color: #EE964B;
}

.event-info-tile.violet header {
    background-color: #B07BAC;
}

.event-info-tile.maroon header {
    background-color: #611C35;
}

.event-info-tile.green header {
    background-color: #337357;
}

.event-info-tile.dark-tan header {
    background-color: #9E7542;
}

.event-info-tile.dark-tan .sub-header {
    background-color: #BC915E;
    color: white;
    padding: .55rem;
}

.event-info-tile.maroon .sub-header {
    background-color: #772E48;
    color: white;
    padding: .55rem;
}

.event-info-tile.maroon .sub-2 .sub-header {
    opacity: .75;
}

.event-info-tile.dark-orange header {
    background-color: #B56B45;
}

.event-info-tile.dark-orange .sub-header {
    background-color: #C68768;
    color: white;
    padding: .55rem;
}

.event-info-tile header {
    height: 4rem;
    display: flex;
    padding: 0 .875rem 0 1.25rem;
    color: white;
    background-color: transparent;
    font-family: "Muli", Georgia, "Times New Roman", Times, serif;
    cursor: pointer;
}

.event-info-tile header > span {
    flex: 1;
    margin: auto;
    font-size: 1.25rem;
    white-space: nowrap;
}

.event-info-tile header i.tile-icon {
    margin-top: auto;
    margin-bottom: auto;
    font-size: 1.5rem;
}

.event-info-tile > .content {
    display: none;
}

.event-info-tile > .content.active {
    display: block;
}

.event-info-tile header .view-mode-buttons {
    margin: auto;
    height: 100%;
}

.event-info-tile header .view-mode-buttons a {
    color: white;
    font-size: 1rem;
    height: 100%;
    padding-right: 0.375rem;
}

.event-info-tile header .view-mode-buttons a + a {
    padding-left: 0.375rem;
    margin-left: 0;
}

.event-info-tile header .edit-mode-buttons {
    margin: auto;
}

.event-info-tile header .edit-mode-buttons a{
    border-radius: .25rem;
    padding: .5rem;
}

.event-info-tile header .edit-mode-buttons a,
.event-info-tile header .edit-mode-buttons a span {
    color: white;
    font-size: .75rem;
    padding: .15rem;
}

.event-info-tile header .edit-mode-buttons a + a {
    margin-left: .75rem;
}

.event-info-tile header .edit-mode-buttons .cancel-button {
    background-color: #a30001;
}

.event-info-tile header .edit-mode-buttons .update-button {
    background-color: #32766e;
}

.attendee-header {
    background-color: #a4896c;
    color: white;
    padding: .55rem;
}

.sub-2 .attendee-header {
    background-color: #D8D1C6;
    color: black;
}

.report-tile-list {
    list-style: none;
    margin: 1rem 0 0 0;
    padding: 0;
}

.report-tile-list li {
    padding: .5rem;
}

.report-header {
    background-color: #F7C073;
    color: white;
}

.event-selection-dropdown {
    width: 100%;
}

.event-info-tile.full-screen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    background-color: white;
    margin-bottom: 0;
}

.event-info-tile.full-screen > header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
}

.event-info-tile.full-screen > .content {
    padding-right: 1rem;
    padding-left: 1rem;
    overflow: auto;
    position: fixed;
    top: 4rem;
    left: 0;
    right: 0;
    bottom: 0;
}

.attendee-settings-checkboxes .checkbox {
    width: 100%;
}

@media (min-width: 768px) {
    .attendee-settings-checkboxes .checkbox {
        width: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/eventLanding.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;;AAGA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;IAC7B,6DAA6D;IAC7D,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".mock-up-image {\r\n    width: 100%;\r\n}\r\n\r\n\r\n@media (min-width: 768px) {\r\n    .mock-up-image {\r\n        width: initial;\r\n    }\r\n}\r\n\r\n.event-info-tile {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.event-info-tile > header {\r\n    position: sticky;\r\n    top: -16px;\r\n    z-index: 1;\r\n}\r\n\r\n.event-info-tile.light-blue header{\r\n    background-color: #005377;\r\n}\r\n\r\n.event-info-tile.blue header {\r\n    background-color: #005337;\r\n}\r\n\r\n.event-info-tile.red header {\r\n    background-color: #95190d;\r\n}\r\n\r\n.event-info-tile.red .sub-header {\r\n    background-color: #C5817B;\r\n    color: white;\r\n    padding: .5rem;\r\n    margin-bottom: 1rem;\r\n    margin-top: 1rem\r\n}\r\n\r\n.event-info-tile.yellow header {\r\n    background-color: #edb901;\r\n}\r\n\r\n.event-info-tile.teal header {\r\n    background-color: #0894a1;\r\n}\r\n\r\n.event-info-tile.tan header {\r\n    background-color: #a4896c;\r\n}\r\n\r\n.event-info-tile.cyan header {\r\n    background-color: #BA324F;\r\n}\r\n\r\n.event-info-tile.darkBlue header {\r\n    background-color: #003d5a;\r\n}\r\n\r\n.event-info-tile.grey header {\r\n    background-color: #034748;\r\n}\r\n\r\n.event-info-tile.purple header {\r\n    background-color: #8a8ac0;\r\n}\r\n\r\n.event-info-tile.orange header {\r\n    background-color: #EE964B;\r\n}\r\n\r\n.event-info-tile.violet header {\r\n    background-color: #B07BAC;\r\n}\r\n\r\n.event-info-tile.maroon header {\r\n    background-color: #611C35;\r\n}\r\n\r\n.event-info-tile.green header {\r\n    background-color: #337357;\r\n}\r\n\r\n.event-info-tile.dark-tan header {\r\n    background-color: #9E7542;\r\n}\r\n\r\n.event-info-tile.dark-tan .sub-header {\r\n    background-color: #BC915E;\r\n    color: white;\r\n    padding: .55rem;\r\n}\r\n\r\n.event-info-tile.maroon .sub-header {\r\n    background-color: #772E48;\r\n    color: white;\r\n    padding: .55rem;\r\n}\r\n\r\n.event-info-tile.maroon .sub-2 .sub-header {\r\n    opacity: .75;\r\n}\r\n\r\n.event-info-tile.dark-orange header {\r\n    background-color: #B56B45;\r\n}\r\n\r\n.event-info-tile.dark-orange .sub-header {\r\n    background-color: #C68768;\r\n    color: white;\r\n    padding: .55rem;\r\n}\r\n\r\n.event-info-tile header {\r\n    height: 4rem;\r\n    display: flex;\r\n    padding: 0 .875rem 0 1.25rem;\r\n    color: white;\r\n    background-color: transparent;\r\n    font-family: \"Muli\", Georgia, \"Times New Roman\", Times, serif;\r\n    cursor: pointer;\r\n}\r\n\r\n.event-info-tile header > span {\r\n    flex: 1;\r\n    margin: auto;\r\n    font-size: 1.25rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.event-info-tile header i.tile-icon {\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.event-info-tile > .content {\r\n    display: none;\r\n}\r\n\r\n.event-info-tile > .content.active {\r\n    display: block;\r\n}\r\n\r\n.event-info-tile header .view-mode-buttons {\r\n    margin: auto;\r\n    height: 100%;\r\n}\r\n\r\n.event-info-tile header .view-mode-buttons a {\r\n    color: white;\r\n    font-size: 1rem;\r\n    height: 100%;\r\n    padding-right: 0.375rem;\r\n}\r\n\r\n.event-info-tile header .view-mode-buttons a + a {\r\n    padding-left: 0.375rem;\r\n    margin-left: 0;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons {\r\n    margin: auto;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons a{\r\n    border-radius: .25rem;\r\n    padding: .5rem;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons a,\r\n.event-info-tile header .edit-mode-buttons a span {\r\n    color: white;\r\n    font-size: .75rem;\r\n    padding: .15rem;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons a + a {\r\n    margin-left: .75rem;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons .cancel-button {\r\n    background-color: #a30001;\r\n}\r\n\r\n.event-info-tile header .edit-mode-buttons .update-button {\r\n    background-color: #32766e;\r\n}\r\n\r\n.attendee-header {\r\n    background-color: #a4896c;\r\n    color: white;\r\n    padding: .55rem;\r\n}\r\n\r\n.sub-2 .attendee-header {\r\n    background-color: #D8D1C6;\r\n    color: black;\r\n}\r\n\r\n.report-tile-list {\r\n    list-style: none;\r\n    margin: 1rem 0 0 0;\r\n    padding: 0;\r\n}\r\n\r\n.report-tile-list li {\r\n    padding: .5rem;\r\n}\r\n\r\n.report-header {\r\n    background-color: #F7C073;\r\n    color: white;\r\n}\r\n\r\n.event-selection-dropdown {\r\n    width: 100%;\r\n}\r\n\r\n.event-info-tile.full-screen {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1001;\r\n    background-color: white;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.event-info-tile.full-screen > header {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n}\r\n\r\n.event-info-tile.full-screen > .content {\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n    overflow: auto;\r\n    position: fixed;\r\n    top: 4rem;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n}\r\n\r\n.attendee-settings-checkboxes .checkbox {\r\n    width: 100%;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .attendee-settings-checkboxes .checkbox {\r\n        width: auto;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
